import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const clientHubStyles = makeStyles((theme: Theme) =>
    createStyles({
        headerInner: {
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: theme.spacing(3),
        },
        dateWrapper: {
            "& .MuiTypography-root": {
                fontSize: 14,
                "&:first-child": {
                    marginRight: theme.spacing(1),
                    color: theme.palette.text.secondary,
                },
                "&:last-child": {
                    color: theme.palette.text.primary,
                },
            },
        },
        body: {
            padding: theme.spacing(2, 4),
        },
        toolbox: {
            display: "flex",
            alignItems: "center",
            marginBottom: theme.spacing(2),
        },
        filtersWrapper: {
            display: "flex",
            flex: 1,
            "& > div": {
                display: "flex",
                flex: 1,
                alignItems: "flex-start",
                flexDirection: "column",
            },
        },
        label: {
            fontSize: 14,
            fontWeight: 500,
            color: theme.palette.text.primary,
            marginBottom: theme.spacing(0.5),
        },
        filterByNameInput: {
            width: "100%",
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(1),
            "& .MuiInputBase-input": {
                height: 22,
            },
            "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                fontSize: 16,
            },
        },
        selectField: {
            width: "100%",
            "& .MuiSelect-select": {
                paddingTop: theme.spacing(2.7),
                paddingBottom: theme.spacing(2.7),
                "& .MuiChip-root": {
                    height: 20,
                    "& .MuiChip-label": {
                        fontSize: 10,
                        paddingLeft: theme.spacing(0.75),
                        paddingRight: theme.spacing(0.75),
                    },
                },
            },
            "& .MuiSelect-icon": {
                fontSize: 16,
                right: theme.spacing(2),
            },
        },
        filterPlaceholderLabel: {
            color: theme.palette.text.disabled,
        },
        selectMenuItem: {
            padding: theme.spacing(1),
            "& .MuiListItemText-primary": {
                fontSize: 16,
                fontWeight: 400,
                color: theme.palette.text.primary,
            },
            "&.Mui-selected": {
                "& .MuiListItemText-primary": {
                    fontWeight: 700,
                },
            },
        },
        selectFilterPaper: {
            borderRadius: theme.spacing(3),
            border: `1px solid ${theme.palette.secondary.light}`,
            boxShadow: "0px 1px 3px 0px #0000001A, 0px 1px 2px 0px #0000000F",
        },
        selectMenuClear: {
            display: "flex",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 2, 1, 2),
        },
        moreRolesChip: {
            width: 22,
            height: 20,
            fontSize: 10,
            fontWeight: 600,
            marginLeft: theme.spacing(0.5),
            borderRadius: theme.spacing(10),
            color: theme.palette.text.primary,
            background: theme.palette.background.paleBlue,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        sectionTitle: {
            fontSize: 20,
            fontWeight: 600,
        },
        errorAlert: {
            justifyContent: "center",
        },
        errorIcon: {
            fontSize: 16,
            marginRight: theme.spacing(0.5),
            alignSelf: "center",
        },
        errorMessage: {
            fontSize: 16,
            fontWeight: 400,
            marginLeft: theme.spacing(0.5),
        },
        tableWrapper: {
            marginBottom: theme.spacing(6),
            borderRadius: theme.spacing(2),
            border: `1px solid ${theme.palette.neutrals.light}`,
        },
        tableHeader: {
            background: theme.palette.background.paleBlue,
            "& .MuiTableCell-root": {
                fontWeight: 700,
                borderBottom: `1px solid ${theme.palette.neutrals.light}`,
                padding: theme.spacing(1.4),
                "& .MuiTypography-root": {
                    fontSize: 16,
                    fontWeight: 700,
                    color: theme.palette.text.primary,
                },
                "&:first-child": {
                    paddingLeft: theme.spacing(2),
                },
                "&:last-child": {
                    paddingRight: theme.spacing(2),
                },
            },
        },
        cellWithSortButton: {
            display: "flex",
            alignItems: "center",
            marginLeft: -8,
        },
        sortButton: {
            fontSize: 14,
            color: theme.palette.neutrals.dark,
        },
        columnsButton: {
            color: theme.palette.button.active.to,
        },
        tableBody: {
            "& .MuiTableCell-root": {
                color: theme.palette.text.secondary,
                padding: theme.spacing(1.2, 1.4),
                "&[data-hidden='true']": {
                    display: "none",
                },
                "&:first-child": {
                    paddingLeft: theme.spacing(2.5),
                },
                "&:last-child": {
                    paddingRight: theme.spacing(2),
                },
            },
        },
        roleSelectMenuItem: {
            "& .MuiListItemText-primary": {
                fontSize: 16,
                fontWeight: 600,
                color: theme.palette.text.primary,
            },
            "& .MuiListItemText-secondary": {
                fontSize: 14,
                fontWeight: 500,
                color: theme.palette.text.disabled,
            },
        },
        removeUserButton: {
            color: theme.palette.text.disabled,
            "&:hover": {
                color: theme.palette.error.main,
            },
        },
        expandableRow: {
            "& .MuiTableCell-root": {
                background: theme.palette.background.grey,
                padding: theme.spacing(0.5, 3),
            },
            "& .MuiTypography-root": {
                fontSize: 12,
                fontWeight: 600,
            },
        },
        noDataWrapper: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            margin: theme.spacing(5, 0),
            "& .MuiTypography-root": {
                fontSize: 16,
                marginBottom: theme.spacing(2),
                "& + .MuiTypography-root": {
                    fontSize: 14,
                    color: theme.palette.text.secondary,
                    marginTop: theme.spacing(-1.5),
                },
            },
        },
        confirmationWrapper: {
            width: "100%",
            maxWidth: 612,
            background: theme.palette.common.white,
            padding: theme.spacing(2),
        },
    })
);

export default clientHubStyles;
